import type * as core from '../../../../../../../core'

// NOTE: mutations in a single `dms.mutate` are not executed in order (only
// insertions are ordered relative to each other), so persona links use
// deterministic IDs (`<changeImpactId>__<personaId>`). Selected links are
// upserted and only deselected links are deleted, which keeps the insertion and
// deletion sets disjoint
export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '[]': [
          {
            '{}': {
              insertion: {
                '{}': {
                  inputs: {
                    '{}': {
                      records: {
                        '[]': [
                          {
                            '{}': {
                              values: {
                                '{}': {
                                  '!id': {
                                    '@$': 'changeImpactId',
                                  },
                                  '!code': {
                                    '@$': 'changeImpactCode',
                                  },
                                  '!name': {
                                    '@$': 'changeImpactName',
                                  },
                                  '!type': {
                                    '@$': 'changeImpactType',
                                  },
                                  '!descr': {
                                    '@$': 'changeImpactDescription',
                                  },
                                  '!phase': {
                                    '@$': 'changeImpactPhase',
                                  },
                                  '!topic': {
                                    '@$': 'changeImpactTopic',
                                  },
                                  '!sprint': {
                                    '@$': 'changeImpactSprint',
                                  },
                                  '!user_story': {
                                    '@$': 'changeImpactUserStory',
                                  },
                                  '!key_benefit': {
                                    '@$': 'changeImpactKeyBenefit',
                                  },
                                  '!future_state': {
                                    '@$': 'changeImpactFutureState',
                                  },
                                  '!current_state': {
                                    '@$': 'changeImpactCurrentState',
                                  },
                                  '!other_comments': {
                                    '@$': 'changeImpactOtherComments',
                                  },
                                  '!area_of_concern': {
                                    '@$': 'changeImpactAreaOfConcern',
                                  },
                                  '!functional_area': {
                                    '@$': 'changeImpactFunctionalArea',
                                  },
                                  '!impacted_groups': {
                                    '@$': 'changeImpactImpactedGroups',
                                  },
                                  '!degree_of_change': {
                                    '@$': 'changeImpactDegreeOfChange',
                                  },
                                  '!validation_status': {
                                    '@$': 'changeImpactValidationStatus',
                                  },
                                  '!target_go_live_date': {
                                    '@$': 'changeImpactTargetGoLiveDate',
                                  },
                                  '!communications_notes': {
                                    '@$': 'changeImpactCommunicationsNotes',
                                  },
                                  '!communications_needed': {
                                    '@$': 'changeImpactCommunicationsNeeded',
                                  },
                                  '!training_implications': {
                                    '@$': 'changeImpactTrainingImplications',
                                  },
                                  '!training_implications_notes': {
                                    '@$': 'changeImpactTrainingImplicationsNotes',
                                  },
                                  '!anticipated_response_of_change': {
                                    '@$': 'changeImpactAnticipatedResponseOfChange',
                                  },
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  modelId: 'ent:!change_impacts:!change_impact',
                },
              },
            },
          },
          {
            '{}': {
              insertion: {
                '{}': {
                  inputs: {
                    '{}': {
                      records: {
                        '@': 'selectedPersonaLinks',
                      },
                    },
                  },
                  modelId: 'ent:!change_impact_personas:!change_impact_persona',
                },
              },
            },
          },
          {
            '{}': {
              deletion: {
                '{}': {
                  ids: {
                    '@': 'deselectedPersonaLinks',
                  },
                  modelId: 'ent:!change_impact_personas:!change_impact_persona',
                },
              },
            },
          },
        ],
      },
      operation: 'dms.mutate',
    },
  },
  subqueries: {
    selectedPersonaLinks: {
      filter: {
        in: [
          {
            '@.': '!id',
          },
          {
            '??': [
              {
                '@>': [
                  {
                    '??': [{ '@$': 'changeImpactPersonas' }, { '{}': {} }],
                  },
                  'ent:!personas:!persona',
                ],
              },
              { '[]': [] },
            ],
          },
        ],
      },
      target: 'ent:!personas:!persona',
      selection: {
        '{}': {
          values: {
            '{}': {
              '!id': {
                '++': [{ '@$': 'changeImpactId' }, '__', { '@.': '!id' }],
              },
              '!code': {
                '++': [{ '@$': 'changeImpactId' }, '__', { '@.': '!id' }],
              },
              '!name': {
                '++': [{ '@$': 'changeImpactCode' }, ' - ', { '@.': '!name' }],
              },
              '!change_impact': {
                '{}': {
                  entityId: 'ent:!change_impacts:!change_impact',
                  recordId: {
                    '@$': 'changeImpactId',
                  },
                },
              },
              '!persona': {
                '{}': {
                  entityId: 'ent:!personas:!persona',
                  recordId: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
        },
      },
    },
    deselectedPersonaLinks: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': ['!change_impact', { ref: { entity: '!change_impact' } }],
              },
              { '@$': 'changeImpactId' },
            ],
          },
          {
            not: {
              in: [
                {
                  '@.': ['!persona', { ref: { entity: '!persona' } }],
                },
                {
                  '??': [
                    {
                      '@>': [
                        {
                          '??': [
                            { '@$': 'changeImpactPersonas' },
                            { '{}': {} },
                          ],
                        },
                        'ent:!personas:!persona',
                      ],
                    },
                    { '[]': [] },
                  ],
                },
              ],
            },
          },
        ],
      },
      target: 'ent:!change_impact_personas:!change_impact_persona',
      selection: {
        '@.': '!id',
      },
    },
  },
}
